/**
 * External dependencies.
 */

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styling( props ) {
	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, '', props );
}

export default styling;
